export const taskType = {0: '日常类', 1: '业务类'}
export const grade = {0: '低', 1: '中', 2: '高', 3: '特急'}
export const methods = {0: '一次办结', 1: '批量提醒', 2: '单户提醒', 3: '跟踪管理'}
